// 裸账号任意手机验证
<template>
<div>
<div class="g-bd">
  <div class="m-tlt">登录前请使用任意手机进行安全验证</div>
  <Form class="m-form iptsBox" ref="form">
    <form-item class='m-ipt ipt-h'>
    <urs-mbinput :newUp="newUp" placeholder="请输入手机号" ref="mbInput"></urs-mbinput>
    </form-item>
    <!-- <div class="u-mLine"><i class="line"></i></div> -->
    <form-item v-if="!newUp" class='m-ipt ipt-f'>
    <urs-input placeholder="请输入短信验证码" ref="smsInput" size="small" :validate="validateSms"><urs-button class='u-btn-sms' ref=smsBtn enableTip="获取验证码"
      :count="smsCount"
      slot="button" @click="onGetSms" ></urs-button>
    </urs-input>
    </form-item>
    <div v-if="showUp!==''" class="m-tlt del-bottom c-main" v-html="showUp"></div>
    <div class="m-btns g-pd">
      <urs-button enableTip="确定" @click="onSubmit"  ref="submitBtn"></urs-button>
    </div>
  </Form>
</div>
</div>
</template>

<script>
import reqProxy from '../util/request'
import util from '../util/util'
import code from '../util/codemapper'

// @NOTE 两个接口返回码文案基本一致，合并一个
let vfmbsmsCode = {
  '431': "请求错误，请您稍后再试",
  '412': "验证码错误次数过多，请明天再试",
  '413': "当日尝试次数过多，请明天再试",
  '443': "请输入正确的短信验证码",
  '430': "此次登录不需要进行密保验证"
}

util.merge(vfmbsmsCode, code);

export default {
  props: {
    options:Object
  },
  data () {
    return {
      smsCount: 29,
      showUp: '',
      newUp:this.options.newUp,
      receiveCode:this.options.receiveCode||'',
      validateSms () {
        let val = this.currentValue,msg={
          errorMsg:'',
          status:true
        };;
        let _regexp = /^[0-9]{6}$/;
        if(!_regexp.test(val)){
         msg.errorMsg='请输入正确的验证码';
         msg.status=false;
        }
        return msg;
      }
    }
  },
  mounted () {
    window.Loading.loading = false;
    if (this.options.errMsg){
      window.showError(this.options.errMsg)
    }
  },
  methods: {
    // 点击确认提交
    onSubmit () {
      // 表单校验
      // if(this.$refs.mbInput.validate()&&this.$refs.smsInput.validate()){
        if (this.newUp){
          // 新版上行
          if(this.validate(this.$refs,['mbInput'])){
            this.changeToNewSmsUp();
          }
        }else{
          // 旧版上行和下行验证
          if(this.validate(this.$refs,['mbInput','smsInput'])){
            this.$refs.submitBtn.state = 'loading';
            // 提交安全手机验证
            let data = {
              un: this.options.un,
              mb: this.$refs.mbInput.value,
              sms: this.$refs.smsInput.currentValue
            }

            reqProxy({
              url: '/vfmbsms',
              method: 'POST',
              contentType: 'application/x-www-form-urlencoded',
              data: data,
              success:(data)=>{
                // 校验成功
                // 回到登录且自动帮助用户登录
                this.$refs.submitBtn.state = 'enable'
                this.$emit('changeToLogin',{autoLogin:1})
              },
              error:(data)=>{
                this.$refs.submitBtn.state = 'enable';
                // 特殊错误-手机号格式错误
                if(data.ret === '401' && data.dt === '09'){
                  window.showError('手机号格式错误');
                  return;
                }
                if(data.ret === '401' && data.dt === '10'){
                  data.ret="40110";
                  this.$emit('changeToLogin',{errMsg:vfmbsmsCode[data.ret]})
                  return;
                }
                // 特殊错误-返回登录界面
                if(data.ret == '430' || data.ret === '434' ||data.ret === '435' || data.ret === '436' || data.ret === '437' ){
                  this.$emit('changeToLogin',{errMsg:vfmbsmsCode[data.ret]})
                  return;
                }
                // 通用错误
                window.showError(vfmbsmsCode[data.ret]);
              }
            })
          }
        }
    },
    validate(refs,array){  //输入框均需要验证
        let children = this.$refs.form.$children,props=[];
        children.forEach(item=>{
          if(item.$options.name=='form-item'){
              props.push(item);
          }
        })
        let errorStatus=true,msg;
        props.forEach(item => {
          msg=item.$children[0].validate();
          if(!msg.status){
            errorStatus=false;
            item.setMsg(msg.errorMsg);
          }
        });
      return errorStatus;
    },
    // 点击获取短信验证码
    onGetSms () {
      // 校验手机号码格式
      if(this.$refs.mbInput.validate()){
        let data = {
          un: this.options.un,
          mb: this.$refs.mbInput.value
        }
        this.$refs.smsBtn.state = 'disable';

        reqProxy({
          url: '/mbsm',
          method: 'GET',
          data: data,
          success:(data)=>{
            // 成功获取短信验证码
            this.$refs.smsBtn.state = 'enable';
            this.$refs.smsBtn.countDown();
            this.showUp = ''

          },
          error:(data)=>{
            this.$refs.smsBtn.state = 'enable';
            // 上行
            if(data.ret === '411'){
              let dt = data.dt;
              if (dt === '02'){
                if (this.$refs.mbInput.value.indexOf('-')>-1){
                    window.showError('请刷新页面重试');
                    return;
                }
                this.receiveCode = data.receiveCode||'';
                this.changeToNewSmsUp()
                // 新版上行
              }else{
                this.showUp = '请用以上手机编辑短信 <strong>'+(data.receiveCode.split(',')[0]||'验证')+'</strong> 发送到 <strong>'+(data.receiveCode.split(',')[1]||'1069 8163 0163 331')+'</strong> 之后将获取到的验证码填入输入框';
              }
              return;
            }
            // 特殊错误-手机号格式错误
            if(data.ret === '401' && data.dt === '09'){
            //  this.$emit('changeToLogin',{errMsg:"手机号格式错误"})
            window.showError('手机号格式错误');
              return;
            }
            if(data.ret==='401'&&data.dt==='10'){
               data.ret='40110';
               this.$emit('changeToLogin',{errMsg:vfmbsmsCode[data.ret]})
            }
            // 特殊错误-返回登录界面
            if(data.ret == '430' || data.ret === '434' ||data.ret === '435' || data.ret === '436' || data.ret === '437' ){
              this.$emit('changeToLogin',{errMsg:vfmbsmsCode[data.ret]})
              return;
            }
            // 通用错误
            window.showError(vfmbsmsCode[data.ret]);
          }
        })
      }
    },
    changeToNewSmsUp () {
      this.$emit('changeModule',{module:'smsup',mobile:this.$refs.mbInput.value,receiveCode:this.receiveCode,fromluo:true,newUp:true})
     },
  }
}
</script>





// WEBPACK FOOTER //
// Verifyluo.vue?389c35ee